export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-900 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-xs mb-4">
                <i className="ri-smartphone-line"></i>
                移动端入口
              </span>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50">
                随时随地 · 畅快吃瓜
              </h2>
              <p className="text-sm text-background-50/60 mt-4 leading-relaxed max-w-lg">
                51暗网吃瓜移动端为您提供与网页版同步的吃瓜体验。
                无论您使用手机还是平板，都能流畅观看<strong className="text-background-50/80">暗网吃瓜视频</strong>，
                随时随地追踪<strong className="text-background-50/80">51吃瓜在线</strong>最新内容，
                让<strong className="text-background-50/80">在线暗网吃瓜</strong>不再受设备限制。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-line"></i>
                  立即体验
                </a>
                <a
                  href="#features"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium text-sm rounded-full border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-information-line"></i>
                  了解更多
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20dark%20theme%20content%20feed%20with%20warm%20red%20and%20amber%20accent%20elements%2C%20floating%20in%20dark%20space%20with%20glowing%20particles%2C%20representing%20mobile%20content%20browsing%2C%20futuristic%20minimal%20style%2C%20no%20text%20no%20faces%20no%20recognizable%20UI&width=500&height=700&seq=app-mobile-mock&orientation=portrait"
                  alt="51暗网吃瓜移动端"
                  className="w-48 md:w-56 rounded-2xl shadow-2xl border border-background-50/10"
                />
                <div className="absolute -bottom-3 -right-3 w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center shadow-lg">
                  <i className="ri-flashlight-line text-background-50 text-lg"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}